/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export enum Agents {
    Bedrock_Agent = 'Bedrock Agent',
    Anthropic_Agent = 'Anthropic Agent',
    Assessment_Agent = 'Assessment Agent',
    FinOps_Agent = 'FinOps Agent',
    Graphion_Agent = 'Graphion Agent',
    Rate_Optimization_Agent = 'Rate Optimization Agent',
    Usage_Optimization_Agent = 'Usage Optimization Agent',
    AppSecOps_Navigator_Agent = 'AppSecOps Navigator Agent'
}
